class Diagnosis2 {
  constructor(diagnosis2) {
    this.diagnosis = diagnosis2;
    this.selectClassName = 'is-selected';
    this.unselectClassName = 'is-unselected';
    this.correctClassName = 'is-correct';
    this.incorrectClassName = 'is-incorrect';
    this.leavingClassName = 'is-question-out';
    this.enteringClassName = 'is-question-in';

    this.intro = this.diagnosis.querySelector('[data-id="intro"]');
    this.questions = this.diagnosis.querySelectorAll('.js-diagnosis2-question');
    this.tips = this.diagnosis.querySelectorAll('.js-diagnosis2-tips');
    this.nextButtons = this.diagnosis.querySelectorAll('.js-diagnosis2-next');
    this.selectButtons = this.diagnosis.querySelectorAll('.js-diagnosis2-button');
    this.retryButtons = this.diagnosis.querySelectorAll('.js-diagnosis2-retry-trigger');

    this.resultContainer = this.diagnosis.querySelector('.js-diagnosis2-answer-container');
    this.resultContents = this.resultContainer.querySelectorAll('.js-diagnosis2-answer');

    this.answerHistory = [];

    this.init();

  }

  init() {

    this.answerHistory = [];
    this.bind();

  }

  bind(){

    this.nextButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleNext(button);
      });
    });

    this.selectButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.answerResponse(button);
      });
    });

    this.retryButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.reset();
      });
    });

  }

  handleNext(button) {
    const nextId = button.dataset.next;
    const currentPanel = button.closest('.js-diagnosis2-question');
    if(nextId !== 'result') {
      const nextPanel = this.diagnosis.querySelector(`.js-diagnosis2-question[data-id="${nextId}"]`);
      if (!nextPanel) return;

      if (currentPanel && currentPanel !== nextPanel) {
        this.transitionQuestion(currentPanel, nextPanel);
      } else {
        this.questions.forEach((q) => {
          q.hidden = q.dataset.id !== nextId;
        });
      }

      this.resultContainer.hidden = true;
    } else {
      if (currentPanel) {
        currentPanel.classList.add(this.leavingClassName);
        currentPanel.addEventListener(
          'animationend',
          () => {
            currentPanel.classList.remove(this.leavingClassName);
            currentPanel.hidden = true;
            this.resultDisplay();
          },
          { once: true }
        );
      } else {
        this.questions.forEach((q) => {
          q.hidden = true;
        });
        this.resultDisplay();
      }

      this.scrollToTop();
    }
  }

  answerResponse(button) {
    const thisQuestion = button.closest('.js-diagnosis2-question');
    const thisTips = thisQuestion.querySelector('.js-diagnosis2-tips');
    const siblingButtons = thisQuestion.querySelectorAll('.js-diagnosis2-button');

    siblingButtons.forEach((b) => {
      b.classList.add(this.unselectClassName);
      b.setAttribute('disabled', 'disabled');
      b.setAttribute('aria-disabled', 'true');
    });

    button.classList.remove(this.unselectClassName);
    button.classList.add(this.selectClassName);

    if (button.dataset.correct === 'true') {
      this.answerHistory.push('1');
      thisTips.classList.add(this.correctClassName);
      thisTips.classList.remove(this.incorrectClassName);
    } else {
      this.answerHistory.push('0');
      thisTips.classList.add(this.incorrectClassName);
      thisTips.classList.remove(this.correctClassName);
    }
    thisTips.hidden = false;
    console.log(this.answerHistory);

  }

  resultDisplay() {
    const correctCount = this.answerHistory.filter((a) => a === '1').length;
    console.log(`正解数: ${correctCount} / ${this.answerHistory.length}`);

    this.resultContents.forEach((content) => {
      console.log(`content: ${content.dataset.correct}, correctCount: ${correctCount}`, content.dataset.correct !== String(correctCount));
      content.hidden = content.dataset.correct !== String(correctCount);
    });

    this.resultContainer.hidden = false;
  }

  transitionQuestion(currentPanel, nextPanel) {
    currentPanel.classList.add(this.leavingClassName);
    currentPanel.addEventListener(
      'animationend',
      () => {
        currentPanel.classList.remove(this.leavingClassName);
        currentPanel.hidden = true;

        nextPanel.hidden = false;
        nextPanel.classList.add(this.enteringClassName);
        nextPanel.addEventListener(
          'animationend',
          () => {
            nextPanel.classList.remove(this.enteringClassName);
          },
          { once: true }
        );
      },
      { once: true }
    );

    this.scrollToTop();
  }

  reset() {
    this.answerHistory = [];
    this.resultContainer.hidden = true;
    this.resultContents.forEach((content) => {
      content.hidden = true;
    });
    this.questions.forEach((question) => {
      question.classList.remove(this.leavingClassName, this.enteringClassName);
      question.hidden = question.dataset.id !== 'intro';
    });
    this.tips.forEach((tip) => {
      tip.classList.remove(this.correctClassName, this.incorrectClassName);
      tip.hidden = true;
    });
    this.selectButtons.forEach((button) => {
      button.classList.remove(this.selectClassName, this.unselectClassName);
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
    });

    this.scrollToTop();
  }

  scrollToTop() {
    const scrollY = window.scrollY || window.pageYOffset;
    const diagnosisTop = this.diagnosis.getBoundingClientRect().top + scrollY;
    if (scrollY <= diagnosisTop - 20) return;
    setTimeout(() => {
      const scrollVolume = this.diagnosis.getBoundingClientRect().top + window.scrollY - 20;
      window.scrollTo({ top: scrollVolume, behavior: 'smooth' });
    }, 10);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const diagnosisEls = document.querySelectorAll('.js-diagnosis2');
  if (!diagnosisEls.length) return;
  diagnosisEls.forEach((diagnosis) => {
    new Diagnosis2(diagnosis);
  });
});
